export const blockIconsMapsLocalCafe = (
	<span className='material-symbols-outlined'>local_cafe</span>
);
